import { projects } from "./registry";
import { users } from "./accounts";
import { DUTY_ROLE } from "../../constants/workResources";

/**
 * 工作項目＝「人 × 資產」的負責關係（ticket 31；ticket 35 收斂為唯一真相）。
 *
 *   { id, userId, resource, recordId, dutyRole, transfer }
 *
 * 機櫃與硬體的管理者現在**只存在這裡** —— 資產資料上那段「姓名（單位）」已經移除,
 * 資產列表與詳情顯示的管理者是讀取時從這份關係算出來的(見 mock/assetManager.js)。
 *
 * 專案還留著自己的 owner 字串(專案模組有自己的票),所以那一類仍由 owner 推導;
 * 等專案也收斂時,把它一起改成明寫即可。
 */

// 機櫃 / 硬體:userId → 該人負責的資料列 id
const MANAGED = {
  cabinet: { 2: [1, 2] },                 // 林機房
  hardware: { 4: [1, 2, 4], 5: [3, 5, 6] }, // 林承翰 / 張家豪
  // 訊息規則管理(WF_v3 票 21):通知規則也是可轉派的負責關係。
  // 規則的 createdBy(王志明/吳文凱)不在 users 種子裡,所以照機櫃/硬體的
  // 模式明寫指派,不從規則資料推導。
  "notify-rule": { 4: [1, 2, 5], 5: [3, 4] }, // 林承翰 / 張家豪
};

let seq = 1;
const relation = (userId, resource, recordId) => ({
  id: seq++,
  userId: Number(userId),
  resource,
  recordId,
  dutyRole: DUTY_ROLE.MANAGE,
  transfer: null,
});

const fromMap = () =>
  Object.entries(MANAGED).flatMap(([resource, byUser]) =>
    Object.entries(byUser).flatMap(([userId, ids]) =>
      ids.map((recordId) => relation(userId, resource, recordId))
    )
  );

// 專案的負責人還是字串「姓名（單位）」,取姓名比對到人;比對不到就略過,
// 寧可少一筆也不要生出指向不存在的人的關係。
const nameOf = (value) => String(value || "").split("（")[0].trim();
const fromProjects = () =>
  projects
    .map((p) => {
      const hit = users.find((u) => u.name === nameOf(p.owner));
      return hit ? relation(hit.id, "project", p.id) : null;
    })
    .filter(Boolean);

const all = [...fromMap(), ...fromProjects()];

// 設計稿(58:14763)的樣本裡有一列是「轉派審核中｜RQ-20260610-007」。
// 沒有這筆的話,那個狀態在畫面上永遠看不到 —— 開發與驗收都會漏掉它。
// 轉派本身(送審、核准後換人)在 ticket 33。
const inTransfer = all.find((r) => r.userId === 5 && r.resource === "hardware");
if (inTransfer) {
  inTransfer.transfer = { toUserId: 4, docNo: "RQ-20260610-007", status: "pending" };
}

export const workItems = all;
